export default "__VITE_ASSET__CdZuVzhK__"